export default "__VITE_ASSET__BsZ1xN2v__"